import {
	Confirm,
	useGetOne,
	useNotify,
	useRecordContext,
	useRefresh,
} from "react-admin";
import { MissionRecord } from "../types";
import { OrganRecord } from "../../organs/types";
import { missionActive } from "../functions";
import { useOrganPermission } from "../../../permissions";
import { useScreenWidth } from "../../../media";
import { useState } from "react";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

const EndMissionButton = () => {
	const mission = useRecordContext<MissionRecord>();
	const refresh = useRefresh();
	const notify = useNotify();
	const [confirmationOpen, setConfirmationOpen] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	const endButtonLabel = useScreenWidth("mobile") ? "End mission" : "End";

	const displayErrorNotification = () =>
		notify("Error trying to end mission", { type: "error" });

	const endMission = () => {
		setIsLoading(true);
		fetch(`/api/missions/${mission.id}/finish`, { method: "POST" })
			.then((response) => {
				setIsLoading(false);
				setConfirmationOpen(false);
				if (response.ok) {
					notify("Mission finished", { type: "success" });
					refresh();
				} else {
					displayErrorNotification();
				}
			})
			.catch(() => {
				setIsLoading(false);
				setConfirmationOpen(false);
				displayErrorNotification();
			});
	};

	return (
		<>
			<Button variant="contained" onClick={() => setConfirmationOpen(true)}>
				{endButtonLabel}
			</Button>
			<Confirm
				isOpen={confirmationOpen}
				loading={isLoading}
				title="End mission"
				content="Are you sure you want to end the mission?"
				onConfirm={endMission}
				onClose={() => setConfirmationOpen(false)}
			/>
		</>
	);
};

export const Header = () => {
	const mission = useRecordContext<MissionRecord>();
	const { data: organ } = useGetOne<OrganRecord>("organs", {
		id: mission.organ_id,
	});
	const { hasPermissionInOrgan: endMissionPermission } =
		useOrganPermission("missions.finish");

	if (!mission) return null;

	const displayEndMissionButton =
		missionActive(mission) && endMissionPermission(mission.organ_id);

	return (
		<Grid container>
			<Grid item xs={displayEndMissionButton ? 9 : 12}>
				<Typography variant="h1">
					{`UNOS ID ${mission.unos_id}`}
					{organ && mission.extra_info && ` - ${mission.extra_info}`}
					{organ && ` - ${organ.name} mission`}
				</Typography>
			</Grid>
			{displayEndMissionButton && (
				<Grid item xs={3} textAlign="right">
					<EndMissionButton />
				</Grid>
			)}
		</Grid>
	);
};
